<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  components: {
  },
  data() {
    return {
    };
  },
  computed: {
  },
  // 监听 $route.name 的变化
  watch: {
    "$route.name": {
      immediate: true, // 组件创建时立即执行一次
      handler(newName) {
        console.log("路由名称发生变化:", newName);
        this.isFixed = newName === "Vescor";
      },
    },
  },
  created() {
  },
  methods: {},
};
</script>
<style>
#app {
}
</style>

